import { render, staticRenderFns } from "./SmeBox.vue?vue&type=template&id=6bb35425&scoped=true&"
import script from "./SmeBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./SmeBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SmeBox.vue?vue&type=style&index=0&id=6bb35425&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb35425",
  null
  
)

export default component.exports